<script>
import {useRoute} from "vue-router";
import {ref} from "vue";
import {useStore} from "vuex";
import Swal from "sweetalert2";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import FooterPage from "@/components/assetComponents/FooterPage.vue";


export default {
  name: "ComparisonProducts",
  components: {FooterPage, NavbarPage, LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let store = useStore()


    let loading = ref(false)

    let product_id_one = ref(useRoute().params.prod_id_one)
    let product_id_two = useRoute().params.prod_id_two
    let sub_cat_id = ref(useRoute().params.sub_cat_id)

    let info_prod_one = ref(store.state.products.comparison_product)
    let options_prod = ref([])
    let info_prod_two = ref(null)

    function load_prods() {

      loading.value = true

      FreeWorld.Heisenberg({action: 'product', id: product_id_one.value,} , 'Element' , true).then((result) => {

        loading.value = false
        let res = result.data
        if (res.status == 'ok' ){
          info_prod_one.value = res
        }

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_prods()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_prods()
            }
          })
        }
      })

    }
    load_prods()

    function ComparisonProducts() {

      loading.value = true
      FreeWorld.Heisenberg({second_product: product_id_two, first_product: product_id_one.value,} , 'Comparison_Prod').then((result) => {

        loading.value = false
        let res = result.data
        info_prod_one.value = res.first_product_data[0]
        info_prod_two.value = res.second_product_data[0]
        change_prods('update')

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              ComparisonProducts()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              ComparisonProducts()
            }
          })
        }
      })

    }

    function change_prods() {

      options_prod.value = info_prod_one.value.option.map(itemA => ({
        id_fitcher: itemA.id_fitcher,
        name: itemA.name_option,
        side1: itemA.value,
        side2: (info_prod_two.value.option.find(itemB => itemB.id_fitcher === itemA.id_fitcher) || { value: 'مشخص نشده' }).value,
      }));

      info_prod_two.value.option.forEach(itemB => {
        if (!options_prod.value.some(item => item.id_fitcher === itemB.id_fitcher)) {
          options_prod.value.push({
            id_fitcher: itemB.id_fitcher,
            name: itemB.name_option,
            side1: 'مشخص نشده',
            side2: itemB.value,
          });
        }
      });

    }


    if (product_id_two != 0) {
      ComparisonProducts()
    }


    function close_prod() {
      info_prod_two.value = null
      product_id_two = 0
    }


    const txtoverflow = document.querySelectorAll('.txtoverflow');

    function startAnimation() {
      txtoverflow.forEach(element => {
        element.classList.add('animate');
      });
    }

    function stopAnimation() {
      txtoverflow.forEach(element => {
        element.classList.remove('animate');
      });
    }

    txtoverflow.forEach(element => {
      element.addEventListener('animationstart', startAnimation);
      element.addEventListener('animationend', stopAnimation);
    });

    return {

      loading,
      product_id_one,
      product_id_two,
      info_prod_two,
      info_prod_one,
      options_prod,
      close_prod,
      sub_cat_id,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center z-3">
      <div class="d-flex align-items-center ">
        <p class="m-0">
          مقایسه محصول
        </p>
        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div v-if="!loading" class="">

      <div class="p-body">
        <div class="d-flex justify-content-between flex-wrap">


          <div v-if="info_prod_one != null && info_prod_two != null " style="flex-basis: 40%"
               class="animate__animated animate__fadeInLeft w-45 p-2 bg-white overflow-hidden flex-grow-1 rounded-4 position-relative">
            <div @click="close_prod" class="close_icon position-absolute z-1">
              <img style="width: 30px" src="../assets/img/closing_prod.svg" alt="">
            </div>
            <div class="position-relative ">
              <div class="animated-background rounded-3">
                <img v-if="info_prod_two.pic1 == null " class="img_products" src="../assets/img/img-notavalible.jpg"
                     alt="">
                <img v-else class="img_products " :src="info_prod_two.pic1" alt="">
              </div>
              <div class="div_star_and_off d-flex justify-content-evenly position-absolute">
                <div v-if="info_prod_two.off_price != null"
                     class="p-2 d-flex bg-main font-5 rounded-pill font-color m-0 mx-3">
                  <span>%</span>
                  <span>{{ info_prod_two.discount }}</span>
                </div>
                <div v-if="info_prod_two.rating_product != null "
                     class="bg-white py-1 px-2 rounded-pill d-flex border-costom align-items-center">

                  <img style="width:15px" src="../assets/img/star_gold.svg" alt="">

                  <p class="font-4 mx-1 m-0 text-center">{{ info_prod_two.rating_product }}</p>
                </div>
              </div>
            </div>
            <br>
            <p class="m-0 font-5 font-bold text-end" :class="{'txtoverflow':info_prod_two.name.length >= 25}">
              {{ info_prod_two.name }}</p>
            <div class="d-flex justify-content-end my-2 ">
              <div class="overflow-hidden">
                <p class="font-5 mx-1 m-0" :class="{'txtoverflow':info_prod_two.name_store.length >= 20}">
                  {{ info_prod_two.name_store }}</p>
              </div>
              <img style="width:15px" class="ml-1" src="../assets/img/shop.svg" alt="">
            </div>
            <div class="d-flex justify-content-end mb-2">
              <p v-if="info_prod_two.off_price != null" class="font-5 m-0 d-flex font-color">
                <span>تومان</span>
                <span>{{ info_prod_two.off_price.toLocaleString() }}</span>
              </p>
              <p class="m-0 font-5 ml-2"
                 :class="info_prod_two.off_price == null ? 'font-color' : 'text-decoration-line-through' ">
                <span v-if="info_prod_two.off_price == null ">تومان</span>
                <span>{{ info_prod_two.price.toLocaleString() }}</span>
              </p>
            </div>
            <div>
              <p v-if="info_prod_two.count != 0 " class="font-4 m-0 text-end font-color">
                موجود
              </p>
              <p v-else class="font-4 m-0 text-end font-color">
                ناموجود
              </p>
            </div>

          </div>

          <!--            *** دیو خالی برای مقایسه ***-->

          <div v-else
                       :to="{name:'SelectProductsComparison' , params:{prod_id_one:product_id_one , sub_cat_id:sub_cat_id}}"
                       style="flex-basis: 40%"
                       class="animate__animated animate__fadeInLeft div_for_Comparison text-decoration-none flex-grow-1 p-2 w-45 bg-white rounded-4">
            <p class="m-0 font-color font-bold w-100">
              انتخاب کالا
            </p>
          </div>


          <div style="flex-basis: 10%" class="flex-grow-1 d-flex justify-content-center align-items-center">
            <img style="width: 40px" src="../assets/img/Comparison.svg" alt="">
          </div>


          <div v-if="info_prod_one != null " style="flex-basis: 40%"
               class="animate__animated animate__fadeIn w-45 p-2 bg-white overflow-hidden flex-grow-1 rounded-4 position-relative">
            <div class="position-relative ">
              <div class="animated-background rounded-3">
                <img v-if="info_prod_one.pic1 == null " class="img_products" src="../assets/img/img-notavalible.jpg"
                     alt="">
                <img v-else class="img_products " :src="info_prod_one.pic1" alt="">
              </div>
              <div class="div_star_and_off d-flex justify-content-evenly position-absolute">
                <div v-if="info_prod_one.off_price != null"
                     class="p-2 d-flex bg-main font-5 rounded-pill font-color m-0 mx-3">
                  <span>%</span>
                  <span>{{ info_prod_one.discount }}</span>
                </div>
                <div v-if="info_prod_one.rating_product != null "
                     class="bg-white py-1 px-2 rounded-pill d-flex border-costom align-items-center">

                  <img style="width:15px" src="../assets/img/star_gold.svg" alt="">

                  <p class="font-4 mx-1 m-0 text-center">{{ info_prod_one.rating_product }}</p>
                </div>
              </div>
            </div>
            <br>
            <p class="m-0 font-5 font-bold text-end" :class="{'txtoverflow':info_prod_one.name >= 25}">
              {{ info_prod_one.name }}</p>
            <div class="d-flex justify-content-end my-2 ">
              <div class="overflow-hidden w-100 text-end">
                <p class="font-5 mx-1 m-0" :class="{'txtoverflow':info_prod_one.name_store >= 20}">
                  {{ info_prod_one.name_store }}</p>
              </div>
              <img style="width:15px" class="ml-1" src="../assets/img/shop.svg" alt="">
            </div>
            <div class="d-flex justify-content-end mb-2">
              <p v-if="info_prod_one.off_price != null" class="font-5 m-0 d-flex font-color">
                <span>تومان</span>
                <span>{{ info_prod_one.off_price.toLocaleString() }}</span>
              </p>
              <p class="m-0 font-5 ml-2"
                 :class="info_prod_one.off_price == null ? 'font-color' : 'text-decoration-line-through' ">
                <span v-if="info_prod_one.off_price == null ">تومان</span>
                <span>{{ info_prod_one.price.toLocaleString() }}</span>
              </p>
            </div>
            <div>
              <p v-if="info_prod_one.count != 0 " class="font-4 m-0 text-end font-color">
                موجود
              </p>
              <p v-else class="font-4 m-0 text-end font-color">
                ناموجود
              </p>
            </div>

          </div>

        </div>
      </div>

      <br>

      <div v-if="info_prod_two != null && info_prod_one != null " class="animate__animated animate__fadeInUpBig p-body">

        <div class="div-information_Comparison bg-white p-body py-3 rounded-4">

          <div class="d-flex w-100 align-items-center justify-content-between">
            <hr class="w-100">
            <p style="white-space: nowrap;" class="font-4 m-0 font-color text-end font-bold">
              : توضیحات
            </p>
          </div>

          <div class="d-flex justify-content-between my-2">

            <div class="w-50 pr-3">

              <p class="font-4 m-0 text-end">{{ info_prod_two.info }}</p>
            </div>

            <div class="div_hr">

            </div>

            <div class="w-50 pl-3">

              <p class="font-4 m-0 text-end">{{ info_prod_one.info }}</p>
            </div>
          </div>

          <div class="d-flex w-100 align-items-center justify-content-between">
            <hr class="w-100">
            <p style="white-space: nowrap;" class="font-4 m-0 font-color text-end font-bold">
              : برند
            </p>
          </div>

          <div class="d-flex justify-content-between my-2">

            <div class="w-50 pr-3">

              <p class="font-4 m-0 text-end">{{ info_prod_two.brand_name }}</p>
            </div>

            <div class="div_hr">

            </div>

            <div class="w-50 pl-3">
              <p class="font-4 m-0 text-end">{{ info_prod_one.brand_name }}</p>
            </div>
          </div>

          <div v-for="item in options_prod" :key="item.id">

            <div class="d-flex w-100 align-items-center justify-content-between">
              <hr class="w-100">
              <p style="white-space: nowrap;" class="font-4 m-0 font-color text-end font-bold">: {{ item.name }}</p>
            </div>

            <div class="d-flex justify-content-between my-2">

              <div class="w-50 pr-3">

                <p class="font-4 m-0 text-end">{{ item.side2 }}</p>
              </div>

              <div class="div_hr">

              </div>

              <div class="w-50 pl-3">
                <p class="font-4 m-0 text-end">{{ item.side1 }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>

  </div>

  <div dir="ltr" id="web" :class="loading ? 'activeClass' : '' " class="bg-main">
    <NavbarPage></NavbarPage>

    <div v-if="!loading" class="w-90 m-auto">

      <div class="p-body">
        <div class="d-flex justify-content-between flex-wrap">

          <div v-if="info_prod_one != null && info_prod_two != null " style="flex-basis: 40%"
               class="animate__animated animate__fadeInLeft w-45 p-2 bg-white overflow-hidden flex-grow-1 rounded-4 position-relative">
            <div @click="close_prod" class="close_icon position-absolute z-1">
              <img style="width: 2.5rem" src="../assets/img/closing_prod.svg" alt="">
            </div>
            <div class="position-relative">
              <div class="animated-background rounded-3">
                <img v-if="info_prod_two.pic1 == null " class="img_products-web" src="../assets/img/img-notavalible.jpg" alt="">
                <img v-else class="img_products-web" :src="info_prod_two.pic1" alt="">
              </div>

              <div class="div_star_and_off d-flex justify-content-evenly position-absolute">
                <div v-if="info_prod_two.off_price != null"
                     class="p-2 d-flex bg-main font-3 rounded-pill font-color m-0 mx-3">
                  <span>%</span>
                  <span>{{ info_prod_two.discount }}</span>
                </div>

                <div v-if="info_prod_two.rating_product != null " class="bg-white py-1 px-3 rounded-pill d-flex border-costom align-items-center">

                  <img style="width:1.5rem" src="../assets/img/star_gold.svg" alt="">

                  <p class="font-3 mx-1 m-0 text-center">{{ info_prod_two.rating_product }}</p>
                </div>
              </div>
            </div>

            <br>

            <p class="m-0 font-3 font-bold text-end" :class="{'txtoverflow':info_prod_two.name.length >= 25}">{{ info_prod_two.name }}</p>
            <div class="d-flex justify-content-end my-2 ">
              <div class="overflow-hidden">
                <p class="font-3 mx-1 m-0" :class="{'txtoverflow':info_prod_two.name_store.length >= 20}">{{ info_prod_two.name_store }}</p>
              </div>
              <img style="width:1.5rem" class="ml-1" src="../assets/img/shop.svg" alt="">
            </div>
            <div class="d-flex justify-content-end mb-2">
              <p v-if="info_prod_two.off_price != null" class="font-3 m-0 d-flex font-color">
                <span>تومان</span>
                &nbsp;
                <span>{{ info_prod_two.off_price.toLocaleString() }}</span>
              </p>


              <p class="m-0 font-3 d-flex ml-2"
                 :class="info_prod_two.off_price == null ? 'font-color' : 'text-decoration-line-through' ">
                <span v-if="info_prod_two.off_price == null ">تومان</span>
                &nbsp;
                <span>{{ info_prod_two.price.toLocaleString() }}</span>
              </p>
            </div>
            <div>
              <p v-if="info_prod_two.count != 0 " class="font-3 m-0 text-end font-color">
                موجود
              </p>
              <p v-else class="font-3 m-0 font-bold text-end font-color-red">
                ناموجود
              </p>
            </div>

          </div>

          <!--            *** دیو خالی برای مقایسه ***-->

          <router-link v-else :to="{name:'SelectProductsComparison' , params:{prod_id_one:product_id_one , sub_cat_id:sub_cat_id}}"
               style="flex-basis: 40%" class="animate__animated animate__fadeInLeft div_for_Comparison text-decoration-none flex-grow-1 p-2 w-45 bg-white rounded-4">
            <p class="m-0 font-color font-bold w-100">
              انتخاب کالا
            </p>
          </router-link>


          <div style="flex-basis: 10%" class="flex-grow-1 d-flex justify-content-center align-items-center">
            <img style="width: 4rem" src="../assets/img/Comparison.svg" alt="">
          </div>


          <div v-if="info_prod_one != null " style="flex-basis: 40%"
               class="animate__animated animate__fadeIn w-45 p-2 bg-white overflow-hidden flex-grow-1 rounded-4 position-relative">
            <div class="position-relative ">
              <div class="animated-background rounded-3">
                <img v-if="info_prod_one.pic1 == null " class="img_products-web" src="../assets/img/img-notavalible.jpg"
                     alt="">
                <img v-else class="img_products-web" :src="info_prod_one.pic1" alt="">
              </div>
              <div class="div_star_and_off d-flex justify-content-evenly position-absolute">
                <div v-if="info_prod_one.off_price != null"
                     class="p-2 d-flex bg-main font-4 rounded-pill font-color m-0 mx-3">
                  <span>%</span>
                  <span>{{ info_prod_one.discount }}</span>
                </div>
                <div v-if="info_prod_one.rating_product != null "
                     class="bg-white py-1 px-2 rounded-pill d-flex border-costom align-items-center">

                  <img style="width:15px" src="../assets/img/star_gold.svg" alt="">

                  <p class="font-3 mx-1 m-0 text-center">{{ info_prod_one.rating_product }}</p>
                </div>
              </div>
            </div>
            <br>
            <p class="m-0 font-3 font-bold text-end" :class="{'txtoverflow':info_prod_one.name >= 25}">
              {{ info_prod_one.name }}</p>
            <div class="d-flex justify-content-end my-2 ">
              <div class="overflow-hidden w-100 text-end">
                <p class="font-3 mx-1 m-0" :class="{'txtoverflow':info_prod_one.name_store >= 20}">
                  {{ info_prod_one.name_store }}</p>
              </div>
              <img style="width:1.5rem" class="ml-1" src="../assets/img/shop.svg" alt="">
            </div>
            <div class="d-flex justify-content-end mb-2">
              <p v-if="info_prod_one.off_price != null" class="font-3 m-0 d-flex font-color">
                <span>تومان</span>
                <span>{{ info_prod_one.off_price.toLocaleString() }}</span>
              </p>
              <p class="m-0 d-flex font-3 ml-2"
                 :class="info_prod_one.off_price == null ? 'font-color' : 'text-decoration-line-through' ">
                <span v-if="info_prod_one.off_price == null ">تومان</span>
                &nbsp;
                <span>{{ info_prod_one.price.toLocaleString() }}</span>
              </p>
            </div>
            <div>
              <p v-if="info_prod_one.count != 0 " class="font-3 m-0 text-end font-color">
                موجود
              </p>
              <p v-else class="font-3 m-0 text-end font-bold font-color-red">
                ناموجود
              </p>
            </div>

          </div>

        </div>
      </div>

      <br>

      <div v-if="info_prod_two != null && info_prod_one != null " class="animate__animated animate__fadeInUpBig p-body">

        <div class="div-information_Comparison bg-white p-body py-3 rounded-4">

          <div class="d-flex w-100 align-items-center justify-content-between">
            <hr class="w-100">
            <p style="white-space: nowrap;" class="font-3 m-0 font-color text-end font-bold">
              : توضیحات
            </p>
          </div>

          <div class="d-flex justify-content-between my-2">

            <div class="w-50 pr-3">

              <p class="font-4 m-0 text-end">{{ info_prod_two.info }}</p>
            </div>

            <div class="div_hr">

            </div>

            <div class="w-50 pl-3">

              <p class="font-4 m-0 text-end">{{ info_prod_one.info }}</p>
            </div>
          </div>

          <div class="d-flex w-100 align-items-center justify-content-between">
            <hr class="w-100">
            <p style="white-space: nowrap;" class="font-3 m-0 font-color text-end font-bold">
              : برند
            </p>
          </div>

          <div class="d-flex justify-content-between my-2">

            <div class="w-50 pr-3">

              <p class="font-4 m-0 text-end">{{ info_prod_two.brand_name }}</p>
            </div>

            <div class="div_hr">

            </div>

            <div class="w-50 pl-3">
              <p class="font-4 m-0 text-end">{{ info_prod_one.brand_name }}</p>
            </div>
          </div>

          <div v-for="item in options_prod" :key="item.id">

            <div class="d-flex w-100 align-items-center justify-content-between">
              <hr class="w-100">
              <p style="white-space: nowrap;" class="font-3 m-0 font-color text-end font-bold">: {{ item.name }}</p>
            </div>

            <div class="d-flex justify-content-between my-2">

              <div class="w-50 pr-3">

                <p class="font-4 m-0 text-end">{{ item.side2 }}</p>
              </div>

              <div class="div_hr">

              </div>

              <div class="w-50 pl-3">
                <p class="font-4 m-0 text-end">{{ item.side1 }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>
.img_products {
  width: 100%;
  height: 150px;
  border-radius: 10px;
}
.img_products-web{
  width: 100%;
  height: 25rem;
  border-radius: 10px;
  object-fit: cover !important;
}

.div_star_and_off {
  bottom: -15px;
  left: 50%;
  transform: translate(-50%);
}

.div_for_Comparison {
  border: 1px solid #FF6F00;
  width: 40%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.div_hr {
  width: 1px;
  background-color: rgba(77, 81, 84, 0.49);
}

.close_icon {
  left: 4px;
  top: 4px;
}

</style>